<template>
  <div>
    <el-row>
      <el-col>
        <el-alert
          title="Solo los archivos PDF pueden ser visualizados, los demás solo podrán ser descargados. El departamento de desarrollo trabajará con eso próximamente."
          type="info"
          center
          show-icon
          effect="dark"
        ></el-alert>
      </el-col>
    </el-row>
    <rabbey-toolbox
      :call-new="callNew"
      :filterables="true"
      @filter-search="filterSearch"
    />
    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :data="items"
          :columns="columns"
          :actions="actions"
          @rtable-push-action="actionHandler"
        />
      </el-col>
    </el-row>

    <el-drawer
      :title="title"
      :visible.sync="legal_visible"
      direction="rtl"
      size="29%"
    >
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <NewDocument
            class="scrollable"
            style="max-height: 800px"
            :Visible="legal_visible"
            ref="myDocument"
            @dialog-closed="legal_visible = false"
            @success="getTableData"
          ></NewDocument>
        </div>
      </div>
    </el-drawer>

    <!-- DRAWER QUE ABRE EL DOCUMENTO PDF -->
    <rabbey-base-drawer
      :drawer.sync="documentDrawer"
      :before-close="resetVariables"
      :destroy-on-close="true"
      size="85%"
    >
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
          class="embed-responsive-item"
          width="100%"
          height="800px"
          :src="fileUrl"
          title="Documento Adjunto"
          allowfullscreen
        >
          ></iframe
        >
      </div>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import NewDocument from "@/views/modules/iso/documents/NewDocument.vue";

export default {
  name: "ISODocuments",
  components: {
    NewDocument
  },
  created() {
    this.getTableData();
  },
  data() {
    return {
      loading: false,
      items: [],
      search: "",
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],
      legal_visible: false,
      documentType: [
        "Formulario",
        "Procedimiento",
        "Instrucciones de trabajo",
        "Normativas",
        "Documento"
      ],
      title: "",
      columns: [
        {
          prop: "DocumentCode",
          label: "Código",
          sortable: true
        },
        {
          prop: "DocumentCategory.Name",
          label: "Nombre de documento",
          width: 250,
          sortable: true,
          formatter: (row) => {
            return row.DocumentCategory.Name;
          }
        },
        {
          prop: "DocumentCategory",
          label: "Tipo de documento",
          sortable: true,
          formatter: (row) => {
            if (row.DocumentCategory.DocumentType == 0) return "Formulario";
            if (row.DocumentCategory.DocumentType == 1) return "Procedimiento";
            if (row.DocumentCategory.DocumentType == 2)
              return "Instrucciones de trabajo";
            if (row.DocumentCategory.DocumentType == 3) return "Normativas";
            if (row.DocumentCategory.DocumentType == 4) return "Documento";
          }
        },
        {
          prop: "DocumentCategory.ProcessNumber",
          label: "No. Versión",
          width: 125,
          sortable: true,
          formatter: (row) => {
            return row.DocumentCategory.ProcessNumber;
          }
        },
        {
          prop: "ISODocumentMasterList",
          label: "Lista Maestra",
          sortable: true,
          formatter: (row) => {
            return row.ISODocumentMasterList.Name;
          }
        },
        {
          prop: "ISODocumentProcess",
          label: "Tipo de proceso",
          sortable: true,
          formatter: (row) => {
            return row.ISODocumentProcess.Name;
          }
        },
        {
          prop: "Status",
          label: "Status",
          sortable: true,
          formatter: (row) => {
            if (row.Status == 0) return "Nuevo";
            if (row.Status == 1) return "En Modificacion";
            if (row.Status == 2) return "En Proceso";
            if (row.Status == 3) return "Aprobado";
            if (row.Status == 4) return "Obsoleto";
          }
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          sortable: true,
          formatter: DatetimeFormatter
        }
        // {
        //   prop: "AttachmentUrl",
        //   label: "Documento",
        //   width: 150,
        //   sortable: true,
        //   formatter: DownLoadFile
        // }
        // {
        //   prop: "Id",
        //   label: "Borrar",
        //   width: 100,
        //   sortable: false,
        //   formatter: DeleteISODoc
        // }
      ],
      //VARIABLES PARA MANEJAR LOS ACTIONS DE LA TABLA
      documentId: 0,
      documentName: "",
      fileUrl: "",
      downloadFile: "",
      isPDF: false,
      documentDrawer: false,

      //VARIABLES PARA CONDICIONAR LA PREGUNTA E ÍCONO DE CONFIRMACIÓN
      confirmationQuestion: "",
      confirmationIcon: ""
    };
  },
  methods: {
    getTableData(options) {
      if (!options) {
        options = {};
      }
      this.loading = true;
      this.$http
        .get("/api/ISODocuments", {
          timeout: 3 * 60 * 1000,
          params: {
            "criteria.CompanyCode": this.currentCompany,
            "criteria.Page": this.currentPage,
            "criteria.Limit": this.pageSize,
            "criteria.Search": this.search
          }
        })
        .then((response) => {
          const {
            data: { Items, ItemCount, CurrentPage }
          } = response;

          this.items = Items;
          this.currentPage = CurrentPage;
          this.totalItems = ItemCount;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },
    filterSearch(searchKey) {
      this.search = searchKey;
      this.getTableData({ Search: searchKey });
    },
    callNew() {
      this.title = "Nuevo documento";
      this.legal_visible = true;
    },
    //METODO PARA MANEJAR LAS ACCIONES DE LA TABLA
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          this.documentName = action.row.DocumentURL;
          var file = this.documentName;
          if (file.substr(file.length - 4) != ".pdf") {
            //valida si el archivo es pdf
            this.confirmationQuestion =
              "Este archivo no es PDF, solo los archivos PDF pueden ser visualizados. ¿Quisiera descargar el archivo?";
            this.confirmationIcon = "info";
            this.isPDF = false;
            this.confirmationAction();
          } else {
            this.isPDF = true;
            this.viewFile(file);
            this.documentDrawer = true;
          }
          break;
        }
        case "delete": {
          if (
            this.IsInRoles([
              this.roles.GerenteDeSoporte,
              this.roles.SuperUsuario,
              this.roles.EncargadaCompras,
              this.roles.GerenteRRHH,
              this.roles.SupervisorDeTécnicos,
              this.roles.GerenciaGeneral,
              this.roles.CoordinadorIso,
              this.roles.DirectorDeProyectos,
              this.roles.CoordinadorDeSoporte,
              this.roles.DirectorAdministrativo,
              this.roles.CoornidadorDeServicioAlCliente,
              this.roles.EncargadoDesarrolloDeAplicaciones,

              this.roles.CEO,
              this.roles.SupervisorDeSoporteDeVentas,
              this.roles.SupervisorDeVentas
            ])
          ) {
            this.documentId = action.row.Id;
            this.confirmationQuestion =
              "¿Está seguro de eliminar este archivo?";
            this.confirmationIcon = "error";
            this.confirmationAction();
          } else {
            this.$message.error(
              "No tienes permiso para eliminar este documento"
            );
          }
          break;
        }
      }
    },
    //METODO PARA MANEJAR LA CONFIRMACIÓN DEL USUARIO AL DESCARGAR O ELIMINAR UN ARCHIVO
    confirmationAction() {
      this.$confirm(this.confirmationQuestion, "Confirmación", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancel",
        type: this.confirmationIcon,
        center: true
      }).then(() => {
        if (this.documentName) {
          this.viewFile(this.documentName);
        } else if (this.documentId) {
          this.deleteDocument(this.documentId);
        }
        this.resetVariables();
      });
    },
    //METODO PARA LIMPIAR LAS VARIABLES CUANDO NO SEAN NECESARIAS
    resetVariables() {
      (this.fileUrl = ""),
        (this.documentName = ""),
        (this.documentId = 0),
        (this.documentDrawer = false);
    },
    //METODO PARA VER/DESCARGAR ARCHIVOS
    viewFile(documentName) {
      this.$http
        .get("/api/ISODocuments/OpenFile", {
          params: {
            documentName: documentName
          }
        })
        .then((response) => {
          if (this.isPDF) {
            this.fileUrl = response.data;
          } else {
            this.downloadFile = response.data;
          }
        })
        .finally(() => {
          if (!this.isPDF) {
            let link = document.createElement("a");
            link.href = this.downloadFile;
            link.download = "download";
            link.click();
            this.fileUrl = "";
          }
        });
      this.fileUrl = "";
    },
    //METODO PARA DESABILITAR LOS DOCUMENTOS
    deleteDocument(id) {
      this.$http
        .delete("/api/ISODocuments/Delete", {
          params: {
            documentId: id
          }
        })
        .then((response) => {
          if (response.data.Succeded) {
            let deletedFileId = this.items.findIndex(
              //getting the id of the clicked item for deletion
              (item) => item.Id == id
            );
            this.items.splice(deletedFileId, 1);
            this.$message({
              type: "success",
              message: "Documento eliminado"
            });
          } else {
            this.$message({
              type: "error",
              message: "Error al eliminar el documento"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
